export default __webpack_public_path__ + "static/media/logoErr.7a081b82.png";